import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import AmbassadorsList from "./AmbassadorsList";
import { Button } from "../../ui-kit/styled-templates";
import axios from "axios";

import moment from "moment";

export default function AdminSearchAmbassadorTool(props) {
    const {
        onSave = d => {

        },
        onAmbassadorAdded = x => {

        }
    } = props;

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(undefined);

    return (
        <Wrapper>


            {user != undefined ? null :
                <>
                    <Row>
                        <Label>
                            Введите почту путешественника
                        </Label>
                        <Input
                            placeholder={"Email"}
                            value={email}
                            onChange={evt => {
                                if (user != undefined) {
                                    setUser(undefined);
                                }
                                setEmail(evt.target.value);
                            }}
                        />
                    </Row>


                    <Row>
                        <Button onClick={async () => {
                            setLoading(true);
                            try {
                                let pld = (await axios.get(`/ambassadors/find-by-email`, {
                                    params: {
                                        email: email
                                    }
                                })).data;
                                if (pld != undefined) {
                                    setUser(pld);
                                }
                            } catch (exc) {

                            }
                            setLoading(false);
                        }}>
                            {loading == true ? "загрузка..." : "Поиск"}
                        </Button>
                    </Row>
                </>
            }

            {user == undefined ? null :
                <div>
                    <div style={{ marginBottom: 20 }}>
                        <span
                            style={{ cursor: "pointer", textDecoration: "underline", opacity: 0.5 }}
                            onClick={() => {
                                setUser(undefined);
                            }}>
                            найти другого пользователя
                        </span>
                    </div>

                    <div>
                        {/*<pre dangerouslySetInnerHTML={{ __html: JSON.stringify(user, null, 2) }}></pre>*/}
                        <div>
                            {`Роль: ${{ "user": "Путешественник", "uni-admin": "Администратор" }[user.userRole]}`}
                            <br />
                            {`Имя: ${user.name}`}
                            <br />
                            {`Email: ${user.email}`}
                            <br />
                            <br />
                            {`Амбассадор: ${user.isAmbassador == true ? "Да" : "Нет"}`}
                        </div>
                        {!(user.userRole == "user" && user.isAmbassador != true) ? null :
                            <div style={{ marginTop: 50 }}>
                                <Button onClick={async () => {
                                    setLoading(true);
                                    try {
                                        let pld = (await axios.put(`/ambassadors`, {
                                            id: user.id,
                                            isAmbassador: true,
                                            ambassadorExpirationTimestamp: +moment().endOf("year")
                                        })).data;
                                        onAmbassadorAdded();
                                    } catch (exc) {

                                    }
                                    setLoading(false);
                                }}>
                                    Сделать амбассадором
                                </Button>
                            </div>
                        }
                    </div>

                </div>
            }

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const Row = styled.div`
  margin-bottom: 10px;
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Input = styled.input`
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  padding-left: 4px;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;